import { io } from 'socket.io-client';

let socket = null;

export function initSocket(token) {
  if (socket) { socket.disconnect(); socket = null; }
  socket = io('/', {
    // Read the token on every (re)connect so refreshed tokens are picked up
    auth: (cb) => cb({ token: localStorage.getItem('kspro_token') || token }),
    transports: ['websocket', 'polling'],
    // Fall back to HTTP long-polling when the WebSocket can't connect (some mobile networks)
    tryAllTransports: true,
  });
  return socket;
}

export function getSocket() { return socket; }

export function disconnectSocket() {
  if (socket) { socket.disconnect(); socket = null; }
}
